import { tReduxAction } from "../types";
import { tSetProfilePreviewAction } from "./types";

export const setProfilePreview = (payload: tSetProfilePreviewAction["payload"]): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "SET_PROFILE_PREVIEW", payload });
  };
};

export const clearProfilePreview = (): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "CLEAR_PROFILE_PREVIEW" });
  };
};
